import {
  Button,
  FormGroup,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Form,
  Label,
  Input,
} from "reactstrap"
import React, { useState } from "react"
import { CKEditor } from "@ckeditor/ckeditor5-react"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"

const TemplateModal = ({
  isOpen,
  toggle,
  templateData,
  setTemplateData,
  onChange,
  onSave,
  type = "",
}) => {
  const [errors, setErrors] = useState({})
  const [editorInstance, setEditorInstance] = useState(null)

  // 🔹 Available placeholders
  const placeholders = [
    "{locationName}",
    "{address}",
    "{services}",
    "{startDate}",
    "{endDate}",
    "{contactPerson}",
    "{contactEmail}",
    "{currentDate}",
  ]

  const validateForm = () => {
    const newErrors = {}

    if (!templateData?.name?.trim()) {
      newErrors.name = "Contract Template name is required"
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSave = () => {
    if (!validateForm()) return
    onSave()
  }

  // 🔹 Insert placeholder at cursor position
  const insertAtCursor = text => {
    if (!editorInstance || type === "view") return

    editorInstance.model.change(writer => {
      const position =
        editorInstance.model.document.selection.getFirstPosition()
      writer.insertText(text, position)
    })
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered fullscreen>
      <ModalHeader toggle={toggle}>
        {type === "view"
          ? "View Contract Template"
          : templateData?.id
          ? "Edit Contract Template"
          : "Add Contract Template"}
      </ModalHeader>

      <ModalBody>
        <Form>
          {/* Template Name */}
          <FormGroup>
            <Label>
              Template Name <span className="text-danger">*</span>
            </Label>
            <Input
              type="text"
              name="name"
              value={templateData?.name || ""}
              onChange={onChange}
              disabled={type === "view"}
              placeholder="Enter template name"
              invalid={!!errors.name}
            />
            {errors.name && (
              <div className="text-danger small mt-1">{errors.name}</div>
            )}
          </FormGroup>

          {/* Placeholders */}
          <FormGroup>
            <Label>
              Template Variables{" "}
              <span className="text-muted">(double click to insert)</span>
            </Label>

            <div className="mb-3 d-flex flex-wrap gap-2">
              {placeholders.map(item => (
                <span
                  key={item}
                  className="badge bg-white p-2 fs-6 text-dark border"
                  style={{ cursor: "pointer", userSelect: "none" }}
                  onDoubleClick={() => insertAtCursor(item)}
                  title="Double click to insert"
                >
                  {item}
                </span>
              ))}
            </div>

            <Label>
              Template Content <span className="text-danger">*</span>
            </Label>
            <div className="big-editor2">
              <CKEditor
                editor={ClassicEditor}
                data={templateData?.content || ""}
                disabled={type === "view"}
                onReady={editor => setEditorInstance(editor)}
                onChange={(event, editor) => {
                  const data = editor.getData()
                  setTemplateData(prev => ({
                    ...prev,
                    content: data,
                  }))
                }}
              />
            </div>
          </FormGroup>
        </Form>
      </ModalBody>

      {type !== "view" && (
        <ModalFooter>
          <Button className="btn-blue" onClick={handleSave}>
            {templateData?.id ? "Update" : "Save"}
          </Button>
          <Button className="btn-cancel" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      )}
    </Modal>
  )
}

export default TemplateModal
